import PropTypes from "prop-types";
import { useRouter } from "next/router";
import { handleize } from "@lib/formatString";
import styles from "./styles/sizes.module.css";

export function Sizes({ sizes, handleSizeChange, showFooter }) {
  const router = useRouter();

  const onClick = (selectedValue) => {
    if (showFooter) {
      const query = {
        ...router.query,
        size: handleize(selectedValue.value),
      };

      router.replace(
        {
          pathname: "/products/[slug]",
          query: query,
        },
        undefined,
        { shallow: true }
      );
    }

    handleSizeChange(selectedValue);
  };

  return (
    <ul className={styles.sizeList}>
      {sizes.map((item) => {
        const { value, labelText, selected } = item;
        const sizeBtnStyles = `
          ${styles.sizeBtn}
          ${selected ? styles.sizeBtnSelected : ""}
        `;
        return (
          <li key={value}>
            <button className={sizeBtnStyles} onClick={() => onClick(item)}>
              {labelText}
            </button>
          </li>
        );
      })}
      <li>&nbsp;</li>
    </ul>
  );
}

Sizes.propTypes = {
  sizes: PropTypes.array.isRequired,
  handleSizeChange: PropTypes.func.isRequired,
  selectedSize: PropTypes.string,
};
